




























import { defineComponent } from '@nuxtjs/composition-api'

// Components
import SliderNavIcon from './icons/SliderNavIcon.vue'

// Types
import { ImageEnhancementConfigInterface } from '~/types/image-enhancement/imageEnhancementTypes'

export default defineComponent({
  name: 'ImageEnhancementFooter',

  components: {
    SliderNavIcon,
  },

  props: {
    config: {
      type: Object as () => ImageEnhancementConfigInterface,
      required: true,
    },
  },

  emits: ['imageEnhancementCarousselPrev', 'imageEnhancementCarousselNext'],

  setup(props) {
    const getTotalSlides = () => {
      return props.config?.images.zoomImagesArray?.length ?? 0
    }

    return {
      getTotalSlides,
    }
  },
})
